//スムーススクロールのJS

window.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('.titleLink_section a');
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
    // console.log(anchorLinks);
    // console.log(anchorLinksArr);
  
    anchorLinksArr.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const targetId = link.hash;
        const targetElement = document.querySelector(targetId);
        const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - 150;
        // console.log(targetElement);
        // console.log(targetOffsetTop);
        window.scrollTo({
            top: targetOffsetTop,
            behavior: "smooth"
        });
      });
    });
});


//アコーディオンのJS
const each_titles = document.querySelectorAll('.faq-block span');
// const each_titlesParents = document.querySelectorAll('.faq-block span').closest('.faq-block');

each_titles.forEach(spanTitle => {
    spanTitle.addEventListener('click', () => {
        spanTitle.closest('.faq-block').classList.toggle('active');
    })
});